// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-3a4a020a] .el-tabs__item.is-active {\n  border: 1px solid #fff !important;\n  border-top-left-radius: 6px;\n  border-top-right-radius: 6px;\n}\n[data-v-3a4a020a] .el-tabs__item {\n  color: #666;\n}\n[data-v-3a4a020a] .el-tabs__header {\n  background-color: #F0F2F8 !important;\n}\n", ""]);
// Exports
module.exports = exports;
